import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController,ModalController } from 'ionic-angular';
import { SportsHomeService, SportsMessageService, SharedService, ConfigService, SportsListingService, SocketService, SocketData, MarketStatus, sportsBetType } from 'baseline-lib';
import { DomSanitizer } from '@angular/platform-browser';
import { Selection, Sportshome } from 'baseline-lib';
import { Market, SportBetPanelService } from 'baseline-lib';
import { SportsBetslipPage } from '../sports-betslip/sports-betslip';
import { WebviewpagesPage } from '../../shared/webviewpages/webviewpages';
import { Event,gameType } from 'baseline-lib'
import { SportsMenuPage } from '../sports-menu-page/sports-menu-page';
import { Global } from '../../../global/global';
import { TranslateService } from '@ngx-translate/core';
import { CustomToast } from '../../shared/services/custom-toast';
import { LoginModalPage } from '../../shared/login-modal/login-modal';
import { RegisterModalPage } from '../../shared/register-modal/register-modal';

/**
 * Generated class for the SportsFullDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-sports-full-detail',
  templateUrl: 'sports-full-detail.html',
})
export class SportsFullDetailPage {
  gameId:any;
  leagueId : any;
  event_id:any;
  _eventDetails: any;
  _eventList: any;
  _matchUrl: any;
  isSelectedMgrId: any;
  _marketData: any[] = [];
  _imageUrl: any;
  _selections: Selection[];
  serverError: any;
  sportsHomeObj: Sportshome;
  current_expanded_event:number =0;
  opened_by_default_event:number = 0;
  is_page_loaded:boolean=false;
  httplink : string;
  showLiveViewer: boolean = false;
  updates_sub : any;
  _marketStatus = MarketStatus;
  public _sportsBetType = sportsBetType;


  constructor(public navCtrl: NavController, public navParams: NavParams,
    public _sportsHomeService: SportsHomeService,
    public _sportMessageServices: SportsMessageService,
    public _sharedService: SharedService,
    public translate : TranslateService,
    private sanitizer: DomSanitizer,
    private _sportBetServices: SportBetPanelService,
    public toast: CustomToast,
    private _configService: ConfigService,
    public loadingCtrl: LoadingController,
    public _sportsListingService: SportsListingService,
    public globalData: Global,
    public modalCtrl : ModalController, public _socketService : SocketService)
    { 
      this._imageUrl = this._configService.getImageUrl();
      this.sportsHomeObj = new Sportshome();
      this._selections = [];
      if(this._sportsListingService.sportsListingObj.selections){
        this._selections = this._sportsListingService.sportsListingObj.selections;
      }
  }

  ngOnInit() {
    //this._sportsHomeService.sportshomeobj.showRouter = true;
    this.sportsHomeObj = this._sportsHomeService.sportshomeobj;
    console.log('ionViewDidLoad SportsFullDetailPage');
    this.showLiveViewer = false;
    this._sportBetServices._removeBetPanel.subscribe(panelId => {
      this._sportsListingService.removePanel(panelId, null, this._marketData);
      //this.RemoveBetPanel(panelId);
    });
    this._sportsListingService.unSubsRemoveBetPanel();
    this.gameId = this.navParams.get('id');
    this.event_id = this.navParams.get('event_id');

    this._sportMessageServices.getGameMarketGrpList(this.event_id,this.gameId)
    .subscribe(
    data => {
      
      if(data.evt)
      {
        this._eventDetails = new Event();
        this._eventDetails.constructEvent(data.evt , gameType.sports);
        console.log("Event Details is ",this._eventDetails)
      }
      if(data.mgli){
        this._eventList = [];
            data.mgli.forEach(marketGrp => {
              var _market = new Market();
              _market.constructMarket(marketGrp);
              this._eventList.push(_market);
            });
      }
      
      if (this._eventDetails) {
        this._matchUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this._configService.getMatchTracURL() + this._eventDetails.merchantid)
      }
      // if (data.mgli && data.mgli[0].mgId) {
      //   this.isSelectedMgrId = data.mgli[0];
      //   this.getMarkets(this.event_id, data.mgli[0].mgId, data.mgli[0].sess);
      // }

      // this._eventList[0].isSessionBet = true;
      if (this._eventList && this._eventList[0].gid) {
          this.isSelectedMgrId = this._eventList[0];
          this.getMarkets(this.event_id, this._eventList[0].gid, this._eventList[0].betTypeFlag);
        }

    },
    error => {
      try{
        this._sharedService.hideContentLoader();
        this.serverError = error.message
        console.log(error.message);
      } catch(err){
          
      }
    });


      //Start sockets updates.
    this.updates_sub = this._socketService.updates.subscribe(data => {
      if (data) {
        try {
          let socketData = JSON.parse(data.toString());
          if (this._marketData && this._marketData.length >= 1) {
            if (socketData && socketData.id == this._eventDetails.eventid) {
              if (this._marketData) {
                var nomarket = false;

                // for making all markets suspended
                if (!socketData.isscr && socketData.st == MarketStatus.AllSuspended) {
                if (!socketData.isscr && (socketData.md == MarketStatus.AllSuspended || socketData.amid == MarketStatus.AllSuspended)) {
                  this._marketData.every((_gameitem, index) => {
                    _gameitem.sli.forEach(a => a.status = MarketStatus.Suspended);
                    _gameitem.status = MarketStatus.Suspended;
                    return true;
                  });
                  return;
                }
              }

                // check market by market id & if not found check by market name 
                var _market = this._marketData.find(a => a.amid == socketData.amid);
                if (!_market) {
                  var league;
                  this._marketData.every((_gameitem, index) => {
                    _market = _gameitem.sli.find(a => a.amid == socketData.amid) ? _gameitem : undefined;
                    if (_market)
                      return false;
                    else
                      return true;
                  });
                }
                if (!_market)
                  _market = this._marketData.find(a => a.mn == socketData.mn);

                if (!_market)
                  nomarket = true;
                else
                  nomarket = false;

                //Actions.
                _market = this._socketService.processSocket(socketData, _market, this._eventDetails);

                // if (nomarket && !socketData.isscr && _market && _market.gid == this.isSelectedMgrId.gid) {
                //   this._marketData.unshift(_market);
                // }

                if (nomarket && !socketData.isscr && _market && _market.gid == this.isSelectedMgrId) {
                  if (this._eventList.filter(_mg => _mg.gid == this.isSelectedMgrId && _mg.betTypeFlag == sportsBetType.SESSION).length > 0) {
                    _market.betTypeFlag = sportsBetType.SESSION;
                    this.sortSessionMarketSelections(_market);
                  }
                  this._marketData.unshift(_market);
                }

              }
            }
          }
        } catch (err) {
          console.log(err);
        }
      }

    });
  }

  getMarketsCopycall(gameId: number, marketGrp: any,){
    this.isSelectedMgrId = marketGrp;
    this.getMarkets(gameId,marketGrp.gid,marketGrp.betTypeFlag);
  }
  expand(amid){
    if(this.opened_by_default_event != 0){
      this.opened_by_default_event = 0;
    }
    if(this.current_expanded_event == amid){
      this.current_expanded_event = 0;
    }else{
      this.current_expanded_event = amid;
    }
  }

  getMarkets(gameId: number, marketGrpId: number, betTypeFlag: number) {
    
    this._sharedService.showContentLoader();
    this._sharedService.showLoader();
    this._sportMessageServices.getMarketData(gameId, marketGrpId)
      .subscribe(
      (data: any) => {
        this._sharedService.hideContentLoader();
        this._sharedService.hideLoader();
        if (data.mli) {

          this._marketData = data.mli;
          var m = new Market();
          this._marketData = m.convertMarket(data.mli);

          this._marketData.forEach(element => {
            element.sli.forEach(sel => {
              sel.isChanged = false;
              this._sportsListingService.sportsListingObj.selections.filter(asel => asel.selected).forEach(alreadySelected => {
                if (alreadySelected.sid == sel.sid && alreadySelected.panel.eid == gameId && alreadySelected.panel.MarketId == element.mid) {
                  sel.selected = true;
                  sel.panel = alreadySelected.panel;
                  sel.pid = alreadySelected.pid;
                }
              });
            });
            if (betTypeFlag == sportsBetType.SESSION) {
              element.betTypeFlag = sportsBetType.SESSION;
              // sort base on enid 1890,1891,1892
              //                    buy,sell, mid
              this.sortSessionMarketSelections(element);
            }
            
          },
          
            error => {
              console.log(error)
            });
            // this._marketData[0].isSessionBet = true;
        }
       
        if(this._marketData && this._marketData.length == 1){
          this.opened_by_default_event = this._marketData[0].amid;
         // this.current_expanded_event = this._marketData[1].amid;
        }
        else if(this._marketData && this._marketData.length > 2){
          this.opened_by_default_event = this._marketData[0].amid;
          this.current_expanded_event = this._marketData[1].amid;
        }
        this.is_page_loaded=true;

        if (data.wschId) {
          this._sportBetServices.manageSockets();
          this._eventDetails.wschid = data.wschId;
          let _socketData: SocketData = new SocketData();
          _socketData.channelId = data.wschId;
          _socketData.isReplacable = true;
          this._sharedService.wschannel_id.next(_socketData);
        }


      });
  }

  sortSessionMarketSelections(_market) {
    _market.sli.sort((a, b) => {
      if (a.enid < b.enid)
        return -1;
      if (a.enid > b.enid)
        return 1;
      return 0;
    });
  }

  BetSelection(_selection: Selection, _market: Market, _event: any) {
    this.globalData.isBetAdded = true;
    if(_event.id)
    _event.eventid = _event.id;
    _event.inplay = this.globalData.inPlay;

    this._sportsListingService.BetSelection(_selection, _market, _event,this._marketData);
   
    if(this._sportBetServices.isMaxPanelCount){
    this.translate.get('Maximum limit reached').subscribe(
      value => 
      {
        this.toast.showError(value);
      });
    }
  }

  openBetSlipPage(){
    this.navCtrl.push(SportsBetslipPage);
  }  

  navigateStats(_eventno: number) {
    this.httplink = this._configService.getMatchStatsURL().concat(_eventno);
    let profileModal = this.modalCtrl.create(WebviewpagesPage, { url: this.httplink });
    profileModal.present();
  }

  openSportsMenuPage(){
    this.navCtrl.push(SportsMenuPage);
  }

  ngOnDestroy() {
    if (this.updates_sub) {
      this.updates_sub.unsubscribe();
    }
    this._sportsListingService.subsRemoveBetPanel();
  }

  toggleLiveViewer() {
    this.showLiveViewer = !this.showLiveViewer;
  }

  loginClicked()
  {
    let profileModal = this.modalCtrl.create(LoginModalPage);
    profileModal.present();    
  }

  registerClicked()
  {
    let registerModal = this.modalCtrl.create(RegisterModalPage);
    registerModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/sports/sports-full-detail/sports-full-detail.ts